import styled from 'styled-components';

import Button from '../../../../../components/Button';
import colors from '../../../../../styles/colors';

import QuickChatContainer from '../../../Chat/pages/QuickChat/QuickChatContainer';

const StyledChatView = styled(QuickChatContainer)`
  width: 100%;
  height: 100%;
  border: none;
  display: flex;
  flex-direction: column;

  .str-chat-channel {
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .str-chat-channel .str-chat__container {
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .str-chat__main-panel {
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .str-chat__list {
    flex: 1;
    overflow-y: auto;
  }

  .str-chat__input-flat {
    flex-shrink: 0;
  }
`;

const Error = styled.div`
  display: flex;
  width: 100%;
  text-align: center;
  padding: 20px;
`;

const StyledButton = styled(Button)`
  background-color: ${colors.base.secondary2};
  color: ${colors.base.alpha};
  border-radius: 50%;
  position: absolute;
  width: 40px;
  height: 40px;
  padding: 8px;
  right: 15px;
  top: 74px;
  cursor: pointer;
  &:hover {
    background-color: ${colors.shades.secondary4};
    color: ${colors.base.secondary2};
    opacity: 1;
  }
`;

const ChatSideBarContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow: hidden;
`;

export {
  StyledChatView,
  ChatSideBarContainer,
  Error,
  StyledButton,
};
